<template>
  <main class="mobile-page user-screen">
    <div class="mobile-screen">
      <header class="mobile-topnav">
        <i class="nav-space"></i>
        <span class="mobile-topnav-title">我的</span>
        <div></div>
      </header>

      <template v-if="isLoggedIn">
        <section class="uc-head">
          <i class="avatar" :class="{ placeholder: !profile.avatar }">
            <img v-if="profile.avatar" :src="profile.avatar" alt="用户头像" />
            <img v-else :src="logo" alt="点指之间 Logo" />
          </i>
          <div>
            <small>线上用户 · ONLINE</small>
            <h1>{{ nickname }}</h1>
            <p>邀请码：{{ inviteCode }}</p>
          </div>
        </section>

        <section class="mobile-card service-card">
          <span class="mobile-eyebrow title">我的服务</span>
          <RouterLink v-for="item in services" :key="item.title" class="cellrow" :to="item.to">
            <i class="cell-ico" :class="item.theme"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path :d="item.icon" /></svg></i>
            <span><strong>{{ item.title }}</strong><p>{{ item.desc }}</p></span>
            <em>›</em>
          </RouterLink>
        </section>

        <button class="mobile-btn mobile-btn-ghost logout" type="button" @click="logout">退出登录</button>
      </template>

      <template v-else>
        <section class="login-guide">
          <i class="guide-mark">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3.2" fill="#04110f" /><circle cx="12" cy="12" r="8" stroke="#04110f" stroke-width="1.8" opacity=".55" /></svg>
          </i>
          <span class="mobile-eyebrow">Account · 账号服务</span>
          <h1>登录后管理你的服务</h1>
          <p>登录点指之间账号后，可以查看官网订单、维护收货地址和管理账号信息。</p>
          <RouterLink class="mobile-btn mobile-btn-primary" to="/mobile/login">立即登录</RouterLink>
          <RouterLink class="mobile-btn mobile-btn-ghost" to="/mobile/download">先下载 APP</RouterLink>
        </section>
      </template>
    </div>
    <MobileTabbar active="user" />
    <MobileServiceFloating />
  </main>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import MobileTabbar from '@/components/mobile/MobileTabbar.vue'
import MobileServiceFloating from '@/components/mobile/MobileServiceFloating.vue'
import { getCurrentUserInfo } from '@/api/user'
import logo from '@/assets-mobile/images/logo.png'

const token = ref(localStorage.getItem('dzzj_website_token') || '')
const phone = ref(localStorage.getItem('dzzj_website_phone') || '')
const profile = ref({})
const isLoggedIn = computed(() => Boolean(token.value))
const nickname = computed(() => profile.value.nickname || (phone.value ? phone.value.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : '官网用户'))
const inviteCode = computed(() => profile.value.inviteCode || '获取中...')
const services = [
  { title: '我的订单', desc: '查看支付状态、审核进度和交付信息', to: '/mobile/orders', theme: 'cyan', icon: 'M5 5h2l1.6 10.2a1.6 1.6 0 0 0 1.6 1.3h7.6a1.6 1.6 0 0 0 1.6-1.3L20.5 8H8' },
  { title: '收货地址', desc: '查看实体产品配送地址', to: '/mobile/address', theme: 'violet', icon: 'M12 21s-6.5-5.3-6.5-10.3a6.5 6.5 0 0 1 13 0C18.5 15.7 12 21 12 21z' },
  { title: '账号资料', desc: '查看基础账号信息', to: '/mobile/profile', theme: 'gold', icon: 'M15.5 5.5 18.5 8.5 8.8 18.2 5 19l.8-3.8z' }
]

function logout() {
  localStorage.removeItem('dzzj_website_token')
  localStorage.removeItem('dzzj_website_refresh_token')
  localStorage.removeItem('dzzj_website_phone')
  token.value = ''
  phone.value = ''
  profile.value = {}
}

onMounted(async () => {
  if (!token.value) return
  try {
    profile.value = await getCurrentUserInfo()
  } catch {
    token.value = localStorage.getItem('dzzj_website_token') || ''
    if (!profile.value.inviteCode) {
      profile.value = { ...profile.value, inviteCode: '暂未获取' }
    }
  }
})
</script>

<style scoped>
.nav-space { width: 36px; }
.uc-head { display: flex; align-items: center; gap: 14px; padding: 16px 4px 18px; }
.avatar { width: 58px; height: 58px; flex: 0 0 58px; overflow: hidden; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(222,246,255,.16); border-radius: 19px; background: radial-gradient(circle at 30% 25%, #8df5de, #46d6b6 65%, #2eb898); box-shadow: 0 10px 28px rgba(70,214,182,.35); }
.avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
.avatar.placeholder { display: flex; align-items: center; justify-content: center; padding: 10px; background: linear-gradient(150deg, rgba(20,34,56,.9), rgba(9,18,33,.95)); }
.avatar.placeholder img { width: 100%; height: auto; object-fit: contain; }
.uc-head div { flex: 1; min-width: 0; }
.uc-head small { display: block; margin-bottom: 4px; color: var(--mobile-gold); font-size: 10px; font-weight: 800; letter-spacing: .14em; }
.uc-head h1 { font-size: 19px; font-weight: 900; line-height: 1.2; }
.uc-head p { margin-top: 4px; color: var(--mobile-quiet); font-size: 12px; font-variant-numeric: tabular-nums; }
.service-card .title { margin-bottom: 4px; }
.cellrow { display: flex; align-items: center; gap: 12px; padding: 14px 0; border-bottom: 1px solid rgba(222,246,255,.07); color: inherit; text-decoration: none; }
.cellrow:last-child { border-bottom: none; }
.cell-ico { width: 38px; height: 38px; flex: 0 0 38px; display: flex; align-items: center; justify-content: center; border-radius: 11px; font-style: normal; }
.cell-ico.cyan { color: var(--mobile-cyan); background: var(--mobile-cyan-soft); }
.cell-ico.violet { color: var(--mobile-violet); background: var(--mobile-violet-soft); }
.cell-ico.gold { color: var(--mobile-gold); background: var(--mobile-gold-soft); }
.cellrow span { flex: 1; min-width: 0; }
.cellrow strong { display: block; font-size: 14px; font-weight: 700; }
.cellrow p { margin-top: 2.5px; color: var(--mobile-quiet); font-size: 11.5px; line-height: 1.45; }
.cellrow em { color: var(--mobile-faint); font-style: normal; }
.logout { width: 100%; margin-top: 16px; }
.login-guide { display: flex; flex-direction: column; align-items: center; padding: 46px 8px 10px; text-align: center; }
.guide-mark { width: 64px; height: 64px; display: flex; align-items: center; justify-content: center; margin-bottom: 16px; border-radius: 20px; background: radial-gradient(circle at 30% 25%, #8df5de, #46d6b6 60%, #2eb898); box-shadow: 0 14px 44px rgba(70,214,182,.4); }
.login-guide h1 { margin: 12px 0 8px; font-size: 24px; font-weight: 900; }
.login-guide p { margin-bottom: 24px; color: var(--mobile-muted); font-size: 12px; line-height: 1.7; }
.login-guide .mobile-btn { width: 100%; }
.login-guide .mobile-btn + .mobile-btn { margin-top: 10px; }
</style>
